import { render, staticRenderFns } from "./VacancyEventCard.vue?vue&type=template&id=68532926&scoped=true&"
import script from "./VacancyEventCard.vue?vue&type=script&lang=js&"
export * from "./VacancyEventCard.vue?vue&type=script&lang=js&"
import style0 from "./VacancyEventCard.vue?vue&type=style&index=0&id=68532926&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68532926",
  null
  
)

export default component.exports